import { Currency } from 'types'
import toPrecisionAmount from './toPrecisionAmount'

/**
 * Utility function for adding currency symbol using currency name to an amount.
 *
 * @param currency Currency
 * @returns
 */

const addCurrencySymbol = (amount: number, currency: Currency) => {
	const precisionAmount = toPrecisionAmount(amount)

	switch (currency) {
		case 'USD':
			return `$ ${precisionAmount}`
		case 'INR':
			return `₹ ${precisionAmount}`
		case 'EUR':
			return `€ ${precisionAmount}`
		case 'IDR':
			return `Rp ${precisionAmount}`
		case 'AUD':
			return `A$ ${precisionAmount}`
		case 'GBP':
			return `£ ${precisionAmount}`
		default:
			return precisionAmount
	}
}

export default addCurrencySymbol
